//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HowItWorks from '~/components/common/HowItWork.vue'

export default {
  components: {
    HowItWorks
  },
  head () {
    return {
      title: this.$t('footer.products-services.installments').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'installments.block3.title',
        steps: [
          'installments.block3.item1',
          'installments.block3.item2',
          'installments.block3.item3'
        ],
        imgs: [
          require('@/assets/img/services/installments/b3-1.png'),
          require('@/assets/img/services/installments/b3-2.png'),
          require('@/assets/img/services/installments/b3-3.png')
        ]
      }
    }
  }
}
